import { ClientBankRulesService } from "./../../../services/catalogs/ClientBankRulesService";
import { ClientBankRulesDto } from "./../../../dtos/catalogs/ClientBankRules/CLientBankRulesDto";
import { CashFlowItemService } from "./../../../services/catalogs/CashFlowItemService";
import { CashFlowItemDetail } from "./../../../components/Pages/Catalogs/cashflowitem/CashflowItemDetail";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCashflowItemDto } from "../../../dtos/catalogs/cashflowitem/CreateCashflowItemDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupClientBankRules } from "../../../components/Shared/NewForms/NFLookupClientBankRules";
import ClientBankRulesList from "../../../components/Pages/Catalogs/ClientBankRules/ClientBankList";
import { ClientBankRulesDetail } from "../../../components/Pages/Catalogs/ClientBankRules/ClientBankDetail";

export const ClientBankRules: IAppEntity = {
  entityType: "catalog",
  title: "Client Bank Rules",
  pluralTitle: "ClientBankRules",
  apiUrl: "clientBankRules",
  apiEnum: ReferenceTypes.CatalogCompanyCashBox,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(ClientBankRulesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ClientBankRulesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupClientBankRules, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new ClientBankRulesService(this.apiUrl);
  },
  getEmptyModel(): ClientBankRulesDto {
    return {
      id: "",
      name: "",
    };
  },
};
